import { edmCampaign } from '@bingads-webui/edm-campaign';

export const fetchLiftExperimentCampaigns = (
  { aid, cid },
  {
    onFailure,
    onSuccess,
    query,
  }
) => edmCampaign
  .Customers.$withKey(cid)
  .Accounts.$withKey(aid)
  .LiftExperimentCampaigns
  .get(query)
  .toPromise()
  .then((response) => {
    onSuccess(response);
  })
  .catch(() => onFailure(_TL_('Failed to fetch campaigns')));
